import { getMarket } from './i18n';

type MarketUri = { marketUid: number; href: string };

function isMarketUriArray(value: unknown): value is MarketUri[] {
  return (
    Array.isArray(value) &&
    value.every(
      (entry) =>
        typeof entry === 'object' &&
        entry !== null &&
        typeof (entry as Record<string, unknown>).marketUid === 'number' &&
        typeof (entry as Record<string, unknown>).href === 'string'
    )
  );
}

export async function getMarketSpecificHref(marketUris: MarketUri[] | undefined): Promise<string | undefined> {
  if (marketUris === undefined) {
    return undefined;
  }
  const userMarket = parseInt(await getMarket(), 10);
  if (userMarket === 0) {
    return undefined;
  }
  return marketUris.find((entry) => entry.marketUid === userMarket)?.href;
}

export async function resolveMarketLink(linkTag: HTMLAnchorElement): Promise<void> {
  const raw = linkTag.dataset.marketUris;
  if (!raw) {
    return;
  }
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return;
  }
  if (!isMarketUriArray(parsed)) {
    return;
  }
  const href = await getMarketSpecificHref(parsed);
  if (href) {
    linkTag.setAttribute('href', href);
  }
}
